import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { Modal } from "../modal";
import PropTypes from "prop-types";

import { SenaSuccessForm } from "./sena-success-form";
import subscriptionSuccessImage from "../../../../assets/images/nl-images/nl-sena-page.png";
import { SocialShare } from "@quintype/components";

import "./show-success-msg.m.css";
import assetify from "@quintype/framework/assetify";
import ShareSuccessMessage from "./share-success-message";

class ShowSuccessMsgBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkSuccessMsg: false,
      showSenaForm: false
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentPath !== prevProps.currentPath) {
      const checkSuccessMsg = this.props.currentPath.indexOf("?subscription-status=success") > -1;
      const showSenaForm = this.props.currentPath.indexOf("sena=true") > -1;
      this.setState({ checkSuccessMsg, showSenaForm });
    }
  }

  OnClick = () => {
    this.props.navigateTo(window.location.pathname);
  };

  render() {
    return (
      <div>
        {this.state.checkSuccessMsg && (
          <Modal onBackdropClick={this.OnClick}>
            <div styleName="modal-content modal-wrapper">
              You’re a star! Thank you so much for paying to keep news free and supporting our journalism. <br />
              {this.state.showSenaForm ? (
                <div styleName="sena-form">
                  <SenaSuccessForm handleClose={this.OnClick} />
                </div>
              ) : (
                <div>
                  <div styleName="image-wrapper">
                    <img
                      styleName="success-image"
                      src={assetify(subscriptionSuccessImage)}
                      alt="subscription success image"
                    ></img>
                  </div>
                  <div styleName="share-wrapper">
                    <div style={{ textAlign: "center", marginBottom: "10px" }}>
                      Spread the message: <div style={{ color: "var(--primary-color)" }}> #PayToKeepNewsFree</div>
                    </div>
                    <SocialShare
                      fullUrl={"https://newslaundry.com/subscription"}
                      title={"I #PayToKeepNewsFree to support independent media\n\n"}
                      services={["facebook", "twitter", "whatsapp", "linkedin"]}
                      story={null}
                      template={ShareSuccessMessage}
                    />
                  </div>
                </div>
              )}
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

ShowSuccessMsgBase.propTypes = {
  currentPath: PropTypes.object,
  navigateTo: PropTypes.func
};

function mapStateToProps(state) {
  return {
    menu: get(state, ["qt", "data", "navigationMenu"], []),
    currentPath: get(state, ["qt", "currentPath"], "")
  };
}

function mapDispatch(dispatch) {
  return {
    navigateTo: url => global.app.navigateToPage(dispatch, url)
  };
}

export const ShowSuccessMsg = connect(mapStateToProps, mapDispatch)(ShowSuccessMsgBase);
